import axios, {cookie, formMulti} from "./axios";

async function GenPost(url, data) {
  try{
    const response = await axios.post(url, data);
    return response.data
  
  } catch (err) {
    
    const error = new Error(err.response?.data?.message || "Erro ao inserir dados");
    error.response = err.response; 
    throw error;
  }
}

async function GenGet(url) {
  try {
    const response = await axios.get(url);
    return response.data;

  } catch (err) {

    const error = new Error(err.response?.data?.message || "Erro ao buscar dados");
    error.response = err.response; 
    throw error;
  }
}

async function GenPostMultiform(url, data) {
  try{
    const response = await formMulti.post(url, data);
    return response.data
  
  } catch (err) {

    const error = new Error(err.response?.data?.message || "Erro ao inserir dados");
    error.response = err.response; 
    throw error;
  }
}

export {
  GenPost,
  GenGet,
  GenPostMultiform,
  }

